module.exports = __webpack_public_path__ + "static/img/female-wave.efb4abb.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/female-wave.gif
// module id = 93
// module chunks = 1